import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "epx_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Public
export async function fetchFlakes() {
  const { data } = await api.get("/flakes");
  return data;
}
export async function fetchCapabilities() {
  const { data } = await api.get("/capabilities");
  return data;
}
export async function aiRender({ imageBase64, flakeId }) {
  const { data } = await api.post(
    "/render",
    { image_base64: imageBase64, flake_id: flakeId },
    { timeout: 120000 },
  );
  return data;
}
export async function submitQuote(payload) {
  const { data } = await api.post("/quote", payload);
  return data;
}

// ----- Admin -----
function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function adminLogin(password, email) {
  const { data } = await api.post("/admin/login", { password, email });
  setToken(data.token);
  return data;
}

export async function adminMe() {
  const { data } = await api.get("/admin/me", { headers: authHeaders() });
  return data;
}

export async function adminFetchQuotes() {
  const { data } = await api.get("/admin/quotes", { headers: authHeaders() });
  return data;
}

export async function adminFetchQuote(id) {
  const { data } = await api.get(`/admin/quotes/${id}`, {
    headers: authHeaders(),
  });
  return data;
}

export async function adminUpdateQuote(id, body) {
  const { data } = await api.patch(`/admin/quotes/${id}`, body, {
    headers: authHeaders(),
  });
  return data;
}

export async function adminDeleteQuote(id) {
  const { data } = await api.delete(`/admin/quotes/${id}`, {
    headers: authHeaders(),
  });
  return data;
}

export function adminCsvUrl() {
  const t = getToken();
  // CSV is served with auth header, so download via fetch + blob
  return { url: `${API}/admin/quotes.csv`, headers: { Authorization: `Bearer ${t}` } };
}

export async function adminUploadFlake(formData) {
  const { data } = await axios.post(`${API}/admin/flakes`, formData, {
    headers: { ...authHeaders() }, // let browser set multipart boundary
  });
  return data;
}

export async function adminDeleteFlake(id) {
  const { data } = await api.delete(`/admin/flakes/${id}`, {
    headers: authHeaders(),
  });
  return data;
}

export async function adminRestoreFlake(id) {
  const { data } = await api.post(
    `/admin/flakes/${id}/restore`,
    {},
    { headers: authHeaders() },
  );
  return data;
}

export async function adminFetchDripsForQuote(quoteId) {
  const { data } = await api.get(`/admin/drips/by-quote/${quoteId}`, {
    headers: authHeaders(),
  });
  return data;
}

export async function adminFetchAllDrips() {
  const { data } = await api.get(`/admin/drips`, { headers: authHeaders() });
  return data;
}

export async function adminRunDripsNow() {
  const { data } = await api.post(
    `/admin/drips/run-now`,
    {},
    { headers: authHeaders() },
  );
  return data;
}

export async function adminQuoteDripOptOut(id) {
  const { data } = await api.post(
    `/admin/quotes/${id}/drip-opt-out`,
    {},
    { headers: authHeaders() },
  );
  return data;
}
